import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DefineVariableModule, OrderByModule } from '@lib/util';
import { DepartmentSearchService } from '../department-search.service';
import { MatButtonModule } from '@angular/material/button';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { TranslateModule } from '@ngx-translate/core';
import { MatListModule } from '@angular/material/list';
import { FormsModule } from '@angular/forms';
import { CustomerDepartmentDto } from '../../types/CustomerDepartment';

export class SelectDepartmentDialogData {
    constructor(public readonly alreadySelectedDepartments: string[]) {}
}

@Component({
    selector: 'department-selection-dialog',
    templateUrl: './department-selection-dialog.component.html',
    styleUrls: ['./department-selection-dialog.component.scss'],
    standalone: true,
    imports: [
        MatButtonModule,
        TranslateModule,
        MatAutocompleteModule,
        MatListModule,
        FormsModule,
        OrderByModule,
        DefineVariableModule,
    ],
})
export class DepartmentSelectionDialogComponent implements OnInit {
    private readonly dialogRef = inject<MatDialogRef<DepartmentSelectionDialogComponent>>(MatDialogRef);
    data = inject<SelectDepartmentDialogData>(MAT_DIALOG_DATA);
    private readonly departmentSearchService = inject(DepartmentSearchService);

    public selectedDepartment: CustomerDepartmentDto | null = null;
    public departments!: CustomerDepartmentDto[];
    public search$: Subject<string> = new Subject<string>();

    constructor() {
        this.search$.pipe(debounceTime(300)).subscribe((query) => this.search(query));
    }

    ngOnInit(): void {
        this.search();
    }

    public search(query = '') {
        this.departmentSearchService.getDepartment(query).subscribe((departments: CustomerDepartmentDto[]) => {
            if (departments.length) {
                this.departments = departments;
            }
        });
    }

    public save(): void {
        this.close(this.selectedDepartment!);
    }

    public selectDepartment(department: CustomerDepartmentDto) {
        this.selectedDepartment = department;

        this.close(this.selectedDepartment);
    }

    public cancel(): void {
        this.dialogRef.close(null);
    }

    private close(result: CustomerDepartmentDto) {
        this.dialogRef.close(result);
    }
}
